import http from './http'

class Contact {
  resendInvite (id) {
    return http.post(`/contacts/${id}/send_welcome_email`)
  }

  create (payload) {
    return http.post(`/contacts/`, { contact: payload })
  }
}

export default new Contact()



// WEBPACK FOOTER //
// ./src/services/contact.js